// Central switch for the Sivo desktop-app download.
//
// The installer is not hosted yet, so DOWNLOAD_URL is empty and every Download
// button across the site renders disabled ("Coming Soon"). When the installer is
// live, set DOWNLOAD_URL to the link (a single universal installer/download page,
// or a downloads landing page) and every Download button enables automatically —
// no other code changes needed.
//
// If you later want per-OS installers, fill MAC/WINDOWS and update the buttons to
// offer both; for now a single link keeps it simple.
// Stable CloudFront keys served from the sivo-downloads-prod bucket. Each release
// overwrites these "latest" keys (see Sivo/upload-installer.sh), so these URLs never change.
export const DOWNLOAD_URL = 'https://d25y31kbn4vkvg.cloudfront.net/mac/Sivo-latest.dmg';
export const DOWNLOAD_URL_MAC = 'https://d25y31kbn4vkvg.cloudfront.net/mac/Sivo-latest.dmg';
// Windows installer (.exe) isn't built/uploaded yet — fill this once it's live.
export const DOWNLOAD_URL_WINDOWS = '';

// True once any download link is configured.
export const isDownloadReady = () =>
  Boolean(DOWNLOAD_URL || DOWNLOAD_URL_MAC || DOWNLOAD_URL_WINDOWS);

// Open the configured download in a new tab. No-op until a link is set.
export const openDownload = () => {
  const url = DOWNLOAD_URL || DOWNLOAD_URL_MAC || DOWNLOAD_URL_WINDOWS;
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
};
